import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import convert from "color-convert";
export function isBright(hexColor) {
  if (!hexColor && 7 !== hexColor.length && 9 !== hexColor.length) return !1;
  if (9 === hexColor.length) return !0;
  var hexRawColor = 7 === hexColor.length ? hexColor : hexColor.substr(0, 7),
    _convert$hex$rgb = convert.hex.rgb(hexRawColor),
    _convert$hex$rgb2 = _slicedToArray(_convert$hex$rgb, 3);
  return (299 * _convert$hex$rgb2[0] + 587 * _convert$hex$rgb2[1] + 114 * _convert$hex$rgb2[2]) / 1e3 > 130;
}